import * as type from 'store/user/userTypes'

export function fetchUser(payload){
    return{
        type: type.FETCH_USER_REQUESTED,
        payload: payload
    }
}


export function fetchUserForComms(payload){
    return{
        type: type.FETCH_USER_FOR_COMMS_REQUESTED,
        payload: payload
    }
}

export function putUserPassword(payload){
    return{
        type: type.PUT_USER_PASSWORD_REQUESTED,
        payload: payload
    }
}

export function updateUserTimezone(payload){
    return{
        type: type.UPDATE_USER_TIMEZONE_REQUESTED,
        payload: payload
    }
}

export function matchCurrentPassword(payload){
    return{
        type: type.PUT_PASSWORD_MATCHES_REQUESTED,
        payload: payload
    }
}


export function fetcAllhUserDetails(){
    return{
        type: type.FETCH_ALL_USERS_DETAILS_REQUESTED,
    }
}

export function updateAllowContactByEmail(payload){
    return{
        type: type.UPDATE_ALLOW_CONTACT_BY_EMAIL_REQUESTED,
        payload
    }
}
